import React, { useContext, useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Select from "react-select";
import DashboardContext from "../../Context/DashboardContext/DashboardContext";
import moment from "moment";
import AuthContext from "../Auth/Middleware/AuthContext";

const GlobalFilterSection = ({
  filterOptIsLoading,
  handleOnGlobelFilterChange,
  globelFilterClick,
  globelFiltersValue,
}) => {
  const { filterOptions } = useContext(DashboardContext);
  const { globalLocationId, globalClientId } = useContext(AuthContext);
  const [locationOptions, setLocationOptions] = useState([]);
  const [locationDisabled, setLocationDisabled] = useState(false);

  const handleDatePickerCancel = (value, fieldName) => {
    handleOnGlobelFilterChange(value, fieldName);
  };

  useEffect(() => {
    if(globalClientId?.value) {
      setLocationOptions(filterOptions?.loc_name?.filter((loc) => loc.client === +globalClientId.value || +globalClientId.value === 0));
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalClientId, filterOptions])
  
  useEffect(() => {
    if(globalLocationId?.value && globalLocationId?.value?.indexOf('_') !== -1) {
      setLocationDisabled(true);
      const locationProcess = globalLocationId?.value?.split('_');
      if(Array.isArray(locationProcess) && locationProcess[0] === 'location' && locationOptions?.length > 0) {
        const selectedLocationObj = locationOptions.filter((location)=>location.value === +locationProcess[1]);
        if(selectedLocationObj[0]){
          handleOnGlobelFilterChange([{label: selectedLocationObj[0].label, value: locationProcess[1]}], "location");
          setTimeout(() => {document.getElementById('global-filter').dispatchEvent(new Event("click", { bubbles: true }))}, 1500);
        }
      }
      if(Array.isArray(locationProcess) && locationProcess[0] === 'process') {
        if(locationProcess[1]){
          handleOnGlobelFilterChange(locationProcess[1], "process");
          setTimeout(() => {document.getElementById('global-filter')?.dispatchEvent(new Event("click", { bubbles: true }))}, 1500);
        }
      }
    } else { 
      setLocationDisabled(false); 
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalLocationId, locationOptions])

  return (
    <div className="row gy-5 g-xl-10">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <div className="card card-flush mb-5">
          <div className="card-body border-0 py-4 ">
            <div className="row">
              <div className="col-lg-3 mb-4">
                <label className="form-label">Location </label>
                <Select
                  isLoading={filterOptIsLoading}
                  id="global-location"
                  options={locationOptions}
                  onChange={(e) => handleOnGlobelFilterChange(e, "location")}
                  name="global-location"
                  isMulti={true}
                  isDisabled={locationDisabled}
                />
              </div>
              <div className="col-lg-3 mb-4">
                <label className="form-label">Primary Speciality </label>
                <Select
                  isLoading={filterOptIsLoading}
                  id="global-speciality"
                  options={filterOptions?.spec_name ?? []}
                  onChange={(e) => handleOnGlobelFilterChange(e, "speciality")}
                  name="global-speciality"
                  isMulti={true}
                />
              </div>
              <div className="col-lg-2 mb-4">
                <label className="form-label">Worklist </label>
                <Select
                  isLoading={filterOptIsLoading}
                  id="global-worklist"
                  options={filterOptions?.worklist ?? []}
                  onChange={(e) => handleOnGlobelFilterChange(e, "Worklist")}
                  name="global-worklist"
                  isMulti={true}
                />
              </div>
              <div className="col-lg-2 mb-4">
                <label className="form-label">Date received </label>
                <DateRangePicker
                  onApply={(e, j) => {
                    handleOnGlobelFilterChange(
                      `${moment(j.startDate).format("L")}-${moment(
                        j.endDate,
                      ).format("L")}`,
                      "date_recieved",
                    );
                  }}
                  initialSettings={{
                    startDate: new Date(),
                    endDate: new Date(),
                    maxDate: new Date(),
                    maxSpan: { days: 15 },
                    locale: { cancelLabel: "Clear" },
                  }}
                  onCancel={() => {
                    handleDatePickerCancel("", "date_recieved");
                  }}
                >
                  <div
                    className="form-control text-sm-left"
                    style={{
                      display: "block ruby",
                      overflow: "hidden",
                      paddingRight: "5px",
                    }}
                  >
                    {globelFiltersValue.date_recieved
                      ? globelFiltersValue.date_recieved
                      : `Select date`}
                  </div>
                </DateRangePicker>
              </div>
              <div className="col-lg-2 mb-4">
                <label className="form-label">Date of service </label>
                <DateRangePicker
                  onApply={(e, j) => {
                    handleOnGlobelFilterChange(
                      `${moment(j.startDate).format("L")}-${moment(
                        j.endDate,
                      ).format("L")}`,
                      "date_of_service",
                    );
                  }}
                  initialSettings={{
                    startDate: new Date(),
                    endDate: new Date(),
                    maxDate: new Date(),
                    maxSpan: { days: 15 },
                    locale: { cancelLabel: "Clear" },
                  }}
                  onCancel={() => {
                    handleDatePickerCancel("", "date_of_service");
                  }}
                >
                  <p
                    className="form-control text-sm-left"
                    style={{
                      display: "block ruby",
                      overflow: "hidden",
                      paddingRight: "5px",
                    }}
                  >
                    {globelFiltersValue.date_of_service
                      ? globelFiltersValue.date_of_service
                      : `Select date`}
                  </p>
                </DateRangePicker>
              </div>
            </div>
            <div className="d-flex justify-content-end p-5 ">
              <button
                id="global-filter"
                onClick={globelFilterClick}
                className="btn btn-primary fs-6"
              >
                Filter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GlobalFilterSection;
